<template>
  <v-btn :loading="loading" :color="btnColor" icon @click="handleClick">
    <span v-html="svg"></span>
  </v-btn>
</template>


<script>
  import { computed, defineComponent } from 'vue'
  export default defineComponent({
    props: {
      loading: {
        type: Boolean,
      },
      started: {
        type: Boolean,
      },
      playing: {
        type: Boolean,
      },
      error: {
        type: Boolean
      }
    },
    setup(props, context){
      const svg = computed(()=>{
        if(!props.started && !props.playing){
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi-volume-high" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.84-5 6.7v2.07c4-.91 7-4.49 7-8.77c0-4.28-3-7.86-7-8.77M16.5 12c0-1.77-1-3.29-2.5-4.03V16c1.5-.71 2.5-2.24 2.5-4M3 9v6h4l5 5V4L7 9H3z" fill="currentColor"></path></svg>';
        } else if(props.playing){
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi-pause-circle-outline" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M13 16V8h2v8h-2m-4 0V8h2v8H9m3-14a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8z" fill="currentColor"></path></svg>';
        } else {
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi-play-circle-outline" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-2 14.5l6-4.5l-6-4.5v9z" fill="currentColor"></path></svg>';
        }
      })

      const btnColor = computed(()=>{
        return props.error ? 'error' : 'normal';
      })

      const handleClick = ()=>{
        context.emit('play-pause');
      }
      
      return {
        svg,
        btnColor,
        handleClick
      }
    }
  })
</script>
